import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { SummaryDesktopContainer } from './SummaryDesktop.container';

app.component('cianAfSummary', react2angular(SummaryDesktopContainer, [], ['config', 'httpApi', 'logger']));
